var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthernetFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 4.86679V5.83329H4.1665V10.8541L6.6665 15.8333V18.3333H13.3332V15.8333L14.213 14.0809L13.2698 13.1376L12.0832 15.5208V17.0833H7.9165V15.5208L5.4165 10.5V7.08329H7.21611L4.99984 4.86679Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8509 11.9706L14.5832 10.5V7.08329H8.96407L7.7142 5.83329H8.2915V4.12496H8.99984V5.83329H10.9998V4.12496H11.7082V5.83329H13.7498V2.91663H6.24984V4.36878L4.99984 3.11865V2.91663C4.99984 2.59718 5.12831 2.30899 5.38525 2.05204C5.6422 1.7951 5.93039 1.66663 6.24984 1.66663H13.7498C14.0693 1.66663 14.3575 1.7951 14.6144 2.05204C14.8714 2.30899 14.9998 2.59718 14.9998 2.91663V5.83329H15.8332V10.8541L14.7973 12.9172L13.8509 11.9706Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31104 2.92891L2.18343 2.05326L17.8084 17.6799L16.9352 18.5547L1.31104 2.92891Z",
    fill: "#FF7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthernetFailed);
export default __webpack_public_path__ + "static/media/ethernet_failed.ca921d21d3818f320b5cb610305ecd4c.svg";
export { ForwardRef as ReactComponent };